export const getSwearWords = (settingSwearWordsMode = '') => {
    if (!settingSwearWordsMode) return []
    let stringWithBadWords = ""
    stringWithBadWords = settingSwearWordsMode.funcs[0]?.code
    const mixDataArray = !!stringWithBadWords ? stringWithBadWords.split('"""') : null
    const swearWords = !!mixDataArray ? mixDataArray[1].split('\n').filter(item => item != "") : []  
    return swearWords

}
    

